import { inject, injectWithTransform, singleton } from "tsyringe";
import {
  ContextRepository,
  FandomContextGroups,
  Logger,
  LoggerTransformer,
} from "@identity/utils";
import { NAVIGATOR } from "@identity/symbols";
import {
  DataWarehouseEventType,
  DataWarehouseService,
} from "../../DataWarehouseService";

@singleton()
export class FacilitatedTesting {
  constructor(
    @injectWithTransform(
      Logger,
      LoggerTransformer,
      "GooglePrivacySandbox:FacilitatedTesting",
    )
    private readonly logger: Logger,
    @inject(ContextRepository)
    private windowContextRepository: ContextRepository,
    @inject(DataWarehouseService)
    private readonly dataWarehouse: DataWarehouseService,
    @inject(NAVIGATOR) private readonly navigator: Navigator,
  ) {}

  public async init(): Promise<void> {
    this.logger.info("FacilitatedTesting init");
    if (this.navigator.cookieDeprecationLabel?.getValue) {
      // Request value and resolve promise
      const label = await this.navigator.cookieDeprecationLabel.getValue();
      if (label) {
        this.logger.info(`Received cookieDeprecationLabel: ${label}`);
        this.windowContextRepository.set(
          FandomContextGroups.tracking,
          "chromeLabel",
          label,
        );
        this.dataWarehouse.track(DataWarehouseEventType.chromeLabel, label);
      } else {
        this.logger.info(`Received empty cookieDeprecationLabel`);
      }
    } else {
      this.logger.info("cookieDeprecationLabel not available");
    }
  }
}
